<template>
    <div>
        <h3 class="is-size-3">Severidad de la Pérdida</h3>
        <p>
            <code>POST {{ host }}/api/firaLossSeverity</code>
        </p>
        <br />
        <h5 class="is-size-6">El endpoint tiene un parámetro opcional:</h5>
        <div class="content">
            <ul>
                <li>
                    <strong>meses</strong>
                    <ul>
                        <li>Opcional</li>
                        <li>Formato numerico</li>
                    </ul>
                </li>
            </ul>
        </div>
        <br />
        <h5 class="is-size-6">
            El endpoint recibe la solicitud en formato JSON:
        </h5>
        <pre>
        <code>
            {
                "meses": 0
            }
        </code>
        </pre>
        <br />
        <h5 class="is-size-6">Respuesta:</h5>
        <pre>
        <code>
            {
                "id": 1,
                "rango_inferior": "-1000.000",
                "rango_superior": "0.000",
                "credito_tipo_1": "0.450",
                "credito_tipo_2": "0.550",
                "credito_tipo_3": "0.750"
            }
        </code>
        </pre>
        <hr />
    </div>
</template>

<script>
export default {
    data () {
        return {
            host: process.env.VUE_APP_HOST
        }
    }
}
</script>

<style lang="scss" scoped>
</style>